<template>
    <div>
        <form-base v-on="$listeners" v-if="!isCard" :value="value" :filter="filter" :hide-delete="hideDelete" :readonly="readonly" :hide-offset="hideOffset" :api-method="apiMethod" :fields="fields" :form-title="formTitle" :is-hover="isHover" />
        <card-base v-on="$listeners" v-if="isCard" :item="value" :filter="filter" :card-color="cardColor" :readonly="readonly" :fields="fields" :title="formTitle" />
    </div>
</template>

<script>
    import enumService from '../services/enumService'
    import frameTypeEnum from '../enums/frameType'

    export default {
        props: [
            'value',
            'filter',
            'hideDelete',
            'readonly',
            'hideOffset',
            'isCard',
            'cardColor',
            'isHover'
        ],

        components: {
            formBase: () => import('../components/FormBase'),
            cardBase: () => import('../components/CardBase')
        },

        data() {
            return {
                memberForm: () => import('../forms/MemberForm'),
                fields: [
                    { type: 'autocomplete', text: 'Member', value: 'memberId', rules: [v => !!v || 'Member is required'], isRequired: true, form: () => import('./MemberForm'), apiMethod: 'Members', claim: 'Members' },
                    { type: 'text', text: 'Name', value: 'name', rules: [v => !!v || 'Name is required', v => !(v && v.length > 100) || 'Name must be less than 100 characters'], isRequired: true, maxLength: 100 },
                    { type: 'enum', text: 'Frame Types', value: 'frameTypes', rules: [v => (v !== null && v !== '' && v.length !== 0) || 'Frame Type is required'], isRequired: true, isMultiple: true, items: enumService.enumAsSelectValueList(frameTypeEnum) },
                    { type: 'number', text: 'Number Of Frames', value: 'numberOfFrames', rules: [v => (v !== null && v !== '') || 'Number Of Frames is required'], isRequired: true },
                    { type: 'autocomplete', text: 'Site', value: 'siteId', rules: [], form: () => import('./SiteForm'), apiMethod: 'Sites', claim: 'Sites' },
                ],
                apiMethod: 'Loads',
                formTitle: 'Load',
            }
        },
    };
</script>
